import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
} from '@angular/core';
import { bindAutoClose } from '@cmps/cdk';
import { Subject } from 'rxjs';

@Directive({
    selector: '[documentBlurTrigger]',
})
export class DocumentBlurTriggerDirective implements OnChanges, OnDestroy {
    @Input() triggerFlag: boolean;
    @Output() documentBlurred: EventEmitter<any>;
    private _cancellationSubject: Subject<void>;

    constructor(private readonly _el: ElementRef) {
        this.documentBlurred = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.triggerFlag && this.triggerFlag === true) {
            this._cancellationSubject = new Subject();
            bindAutoClose(
                'click|escape',
                this._el.nativeElement,
                [this._el.nativeElement],
                () => this.documentBlurred.emit(false),
                this._cancellationSubject,
            );
        }
        if (changes.triggerFlag && this.triggerFlag !== true) {
            this._cancellationSubject?.next();
            this._cancellationSubject?.complete();
        }
    }

    ngOnDestroy(): void {
        this._cancellationSubject?.next();
        this._cancellationSubject?.complete();
        this.documentBlurred.complete();
    }
}
